import { onMount, onCleanup, createEffect } from "solid-js";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import { Mention, MentionBlot } from "quill-mention";
import QuillTableBetter from 'quill-table-better';
import { getUsers } from "../auth";
import 'quill-mention/dist/quill.mention.min.css';
import 'quill-table-better/dist/quill-table-better.css';
import './RichTextEditor.css';

const RichTextEditor = (props) => {
  let editorElement;
  let quill;

  onMount(() => {
    let mention = {};

    const hasBetterTables = Quill.import['modules/table-better'];

    if (!hasBetterTables) {
      Quill.register({
        'modules/table-better': QuillTableBetter
      }, true);
    }

    if ('mention' in props) {
      const hasMention = Quill.imports["modules/mention"];
      if (!hasMention) Quill.register({ "blots/mention": MentionBlot, "modules/mention": Mention });

      mention = {
        allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
        mentionDenotationChars: ["@"],
        source: async function (searchTerm, renderList) {
          const values = (await getUsers()).map(u => ({ id: u.id, value: u.name }));

          if (searchTerm.length === 0) {
            renderList(values, searchTerm);
          } else {
            const matches = [];
            for (let i = 0; i < values.length; i++)
              if (
                ~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())
              )
                matches.push(values[i]);
            renderList(matches, searchTerm);
          }
        }
      };

    }

    const modules = {
      toolbar: [
        [{ header: [1, 2, false] }],
        ["bold", "italic", "underline"],
        ["link", "image", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["clean"],
        [{ 'color': [] }, { 'background': [] }],
        ['table-better'],
      ],
      'table-better': {
        language: 'en_US',
        menus: ['column', 'row', 'merge', 'table', 'cell', 'wrap', 'copy', 'delete'],
        toolbarTable: true
      },
    }

    if ('mention' in props) {
      modules.mention = mention;
    }

    quill = new Quill(editorElement, {
      theme: "snow",
      modules,
      placeholder: props.placeholder || "Compose something...",
    });

    if (props.value) {
      quill.root.innerHTML = props.value;
    }

    quill.on("text-change", () => {
      props.onChange?.(quill.root.innerHTML);
    });
  });

  createEffect(() => {
    const val = props.value;
    if (quill && quill.root.innerHTML !== val) {
      // If the value is empty or significantly different, update the editor
      // This is primarily for clearing the editor from the outside
      if (!val || val === "<p><br></p>") {
        quill.root.innerHTML = val || "";
      }
    }
  });

  onCleanup(() => {
    if (editorElement) {
      editorElement.innerHTML = "";
    }
  });

  return (
    <div style={{ height: props.height || "200px", "margin-bottom": "42px" }}>
      <div ref={editorElement} />
    </div>
  );
};

export default RichTextEditor;
